// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_gr-1";
export var quotedThread = "_gr-0";